import { NavLink, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AppLayout from '../components/AppLayout';

const SECTIONS = [
  { path: '/admin/analytics', label: 'Analytics' },
  { path: '/admin/users', label: 'Users' },
];

/**
 * The admin space: one page, one gate, a tab per section.
 *
 * Everything superadmin-only lives under /admin/* and is reached from a single
 * sidebar entry. The gate is here rather than in each section, so a new
 * section cannot be added without it.
 */
export default function Admin() {
  const { user } = useAuth();

  if (!user?.is_superadmin) return <Navigate to="/" replace />;

  return (
    <AppLayout title="Admin">
      <div className="max-w-7xl mx-auto md:p-2 md:pt-6">
        <nav className="flex gap-1 border-b border-border mb-6">
          {SECTIONS.map((s) => (
            <NavLink
              key={s.path}
              to={s.path}
              className={({ isActive }) => `px-3 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${
                isActive
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              }`}
            >
              {s.label}
            </NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </AppLayout>
  );
}
